import React, { useState, useEffect, useCallback } from 'react'
import { useModal } from 'react-modal-hook'
import { Formik, Form } from 'formik'
import { useSelector } from 'react-redux'
import Modal from '../../../components/Modal/Modal'
import InputError from '../../../components/InputError/InputError'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import NeoLoader from '../../../components/FormComponents/NeoLoader'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoInput from '../../../components/NeoInput/NeoInput'
import { useHistory } from 'react-router-dom'

import NumberFormat from 'react-number-format'
import AccountDisplay from '../../../components/account-display/account-display'
import { values } from 'lodash'
import { getCurrentAccDetailsSelector } from '../../../store/selectors/app.selector'
import { ChequeBookRequestSchema } from '../../../schemas/requests'
import LayoutWithAccountCard from '../../Layout/layout-account-card'
import RequestService from '../../../services/request.service'
import { BUTTON_KEYS, CHEQUE_BOOK_REQUEST_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
const chequeBookConfig = validationConfig['OtherService']['chequeBook']

const chequeBookValues = [25, 50, 100]
const noOfChequeBooksList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
export default function ChequeBookRequest() {
  const history = useHistory()
  const [stage, setStage] = useState(0)
  const [message, setMessage] = useState('')
  const currentAccountDetail = useSelector(getCurrentAccDetailsSelector)
  const [branches, setBranches] = useState([])
  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false)
  const [loadingEligibility, setLoadingEligibility] = useState(false)
  const [formValues, setFormValues] = useState({
    accountNum: '',
    pickUpBranch: '',
    numberOfLeaves: '',
    noOfChequeBooks: '',
  })
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [verifyDetails, setVerifyDetails] = useState({})
  const { t } = useTranslation()

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{message?.message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
                // history.push('/requests')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )
  useEffect(() => {
    getAllBranches()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderForm()
      case 1:
        return renderConfirmation()
      case 3:
        return (
          <NeoOTP otp={otp} setOTP={setOtp} onSubmit={chequeBookFormRequest} loading={loading} />
        )
      case 4:
        return <NeoSuccess message={message} linkPath='/requests' />
      default:
        return <NeoLoader />
    }
  }

  const getAllBranches = useCallback(async () => {
    setLoading(true)
    try {
      const response = await RequestService.getAllBranches({})
      if (response.status === 200) {
        setBranches(response.data)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      // setMessage(err.data.message)
      // //showModal()
    }
  }, [])

  //   const checkAccountEligibility = useCallback(
  //     async (values) => {
  //       setLoading(true)
  //       setFormValues(values)
  //       try {
  //         const response = await RequestService.validateAccChequeFlag(currentAccountDetail)
  //         if (response.status !== 'OK') {
  //           setLoading(false)
  //           setMessage(response)
  //           //showModal()
  //           return
  //         }
  //         setStage(1)
  //         setLoading(false)
  //       } catch (err) {
  //         setLoading(false)
  //         setMessage(err.data.message)
  //         //showModal()
  //       }
  //     },
  //     [currentAccountDetail],
  //   )

  const validateChequeBookFormRequest = useCallback(
    async (values) => {
      try {
        setLoading(true)
        setFormValues(values)
        const brnDetails = branches.filter((ele) => ele.address === values.pickUpBranch)[0]
        const reqParams = {
          accountNo: currentAccountDetail.accountNo,
          noOfChequeLeaves: values.numberOfLeaves,
          pickupBranch: brnDetails.branchCode,
          randomKey: '',
          branchCode: currentAccountDetail.brnCode,
          address: values.pickUpBranch,
          noOfChequeBooks: values.noOfChequeBooks,
          customerId: currentAccountDetail.custNo
        }

        const response = await RequestService.verifyCheckbook(reqParams)
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnable'])
          setVerifyDetails(response.data)
          setStage(1)
          setLoading(false)
        }
      } catch (err) {
        // setMessage(err?.data)
        setLoading(false)
        // //showModal()
      }
    },
    [branches, currentAccountDetail],
  )

  const chequeBookFormRequest = useCallback(async () => {
    try {
      setLoading(true)
      const brnDetails = branches.filter((ele) => ele.address === formValues.pickUpBranch)[0]
      const reqParams = {
        accountNo: currentAccountDetail.accountNo,
        noOfChequeLeaves: formValues.numberOfLeaves,
        pickupBranch: brnDetails.branchCode,
        randomKey: verifyDetails.randomKey,
        branchCode: currentAccountDetail.brnCode,
        otp: otp,
        address: formValues.pickUpBranch,
        noOfChequeBooks: formValues.noOfChequeBooks,
        customerId: currentAccountDetail.custNo
      }
      const response = await RequestService.confirmCheckbook(reqParams)
      if (response.status === 200) {
        setMessage(response.data['message'])
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      setOtp('')
      setLoading(false)
      // setMessage(err?.data)
      // //showModal()
    }
  }, [formValues, otp, branches, currentAccountDetail, verifyDetails])

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(CHEQUE_BOOK_REQUEST_KEYS.CONFIEM_TITLE)}</h3>

        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <div>
          <h6 className='label'>{t(CHEQUE_BOOK_REQUEST_KEYS.PICK_UP_BRANCH)}</h6>
          <h6 className='value'>{formValues.pickUpBranch}</h6>
        </div>
        <div>
          <h6 className='label'>{t(CHEQUE_BOOK_REQUEST_KEYS.NO_OF_LEAVES)}</h6>
          <h6 className='value'>{formValues.numberOfLeaves}</h6>
        </div>

        <div>
          <h6 className='label'>{t(CHEQUE_BOOK_REQUEST_KEYS.NO_OF_BOOKS)}</h6>
          <h6 className='value'>{formValues.noOfChequeBooks}</h6>
        </div>
        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              mode='newDesign'
              type='button'
              className='btn btn-neo'
              onClick={() => (otpEnabled ? setStage(3) : chequeBookFormRequest())}
              text={t(BUTTON_KEYS.CONFIRM)}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(0)}>
          {t(BUTTON_KEYS.BACK)}
        </div>
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>{t(CHEQUE_BOOK_REQUEST_KEYS.TITLE)}</div>
        <Formik
          initialValues={formValues}
          validationSchema={ChequeBookRequestSchema}
          onSubmit={validateChequeBookFormRequest}>
          {({ isSubmitting, handleChange, errors, touched }) => (
            <Form>
              <AccountDisplay currentAccountDetail={currentAccountDetail} />
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='1'
                    showAsterisk={chequeBookConfig['pickUpBranch']}
                    mode='select'
                    text={t(CHEQUE_BOOK_REQUEST_KEYS.PICK_UP_BRANCH)}
                    name='pickUpBranch'
                    disabled={loadingEligibility}
                    onChange={handleChange}
                    list={branches}
                    keyValue='address'
                    value={values.pickUpBranch}
                  />
                  <InputError text={errors.pickUpBranch} touched={touched.pickUpBranch} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='2'
                    showAsterisk={chequeBookConfig['numberOfLeaves']}
                    mode='select'
                    text={t(CHEQUE_BOOK_REQUEST_KEYS.NO_OF_LEAVES)}
                    name='numberOfLeaves'
                    disabled={loadingEligibility}
                    onChange={handleChange}
                    list={chequeBookValues}
                    keyValue={null}
                    value={values.numberOfLeaves}
                  />
                  <InputError text={errors.numberOfLeaves} touched={touched.numberOfLeaves} />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='3'
                    showAsterisk={chequeBookConfig['numberOfBooks']}
                    mode='select'
                    text={t(CHEQUE_BOOK_REQUEST_KEYS.NO_OF_BOOKS)}
                    name='noOfChequeBooks'
                    disabled={loadingEligibility}
                    onChange={handleChange}
                    list={noOfChequeBooksList}
                    keyValue={null}
                    value={values.noOfChequeBooks}
                  />
                  <InputError text={errors.noOfChequeBooks} touched={touched.noOfChequeBooks} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group  col-12'>
                  {isSubmitting ? (
                    <NeoLoader />
                  ) : (
                    <NeoButton
                      tabIndex='4'
                      type='submit'
                      mode='newDesign'
                      disabled={loadingEligibility}
                      text={t(BUTTON_KEYS.SUBMIT)}
                    />
                  )}
                </div>
              </div>
              <div className='back-cancel-btn-container'>
              <button tabIndex={'5'} className='back-cancel-btn btn btn-sm new-design-warning-text-color' onClick={() => history.goBack()}>
                {t(BUTTON_KEYS.CANCEL)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='REQUEST_CHEQUE_BOOK'>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
